export const APP_NAME = 'Exiftrator';
export const HOME_PAGE_TITLE = `${APP_NAME} - Free image metadata editor`;

export function formatPageTitle(pageName: string): string {
  return `${pageName} - ${APP_NAME}`;
}

const WORKSPACE_PAGE_TITLES: Record<string, string> = {
  editor: 'Editor',
  table: 'Table',
  calendar: 'Calendar',
  timelineV3: 'Timeline',
  preferences: 'Settings',
};

export function getWorkspacePageTitle(viewMode: string): string {
  return formatPageTitle(WORKSPACE_PAGE_TITLES[viewMode] ?? 'Editor');
}
